import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TYPE_ALERT } from './snackbar.service';

export interface Notification {
    type: TYPE_ALERT;
    title: string;
    description: string;
    code: number;
    correlationId?: string;
    meta?: Array<{ field: string; message: string }> | string;
}

@Injectable()
export class NotificationService {

    notifications = [];
    public notificationsSource = new BehaviorSubject<Notification[]>([]);
    notifications$ = this.notificationsSource.asObservable();

    addNotification(notification: Notification) {
        this.notifications.unshift(notification);
        this.notifications = this.notifications.slice(0, 10);
        this.notificationsSource.next(this.notifications);
    }

}
